export function redirect(url: string): void {
	window.location.href = url;
}
